import Async from './Async';

export default Async;